import { Controller } from "@hotwired/stimulus"

// Toggles import guide visibility and switches between platform-specific guides.
//
// Usage:
//   <div data-controller="import-guide">
//     <button data-action="click->import-guide#toggle">How to import</button>
//     <div data-import-guide-target="content" class="hidden">
//       <select data-action="change->import-guide#switchPlatform" data-import-guide-target="selector">
//         <option value="klaviyo">Klaviyo</option>
//         <option value="mailchimp">Mailchimp</option>
//       </select>
//       <div data-import-guide-target="guide" data-platform="klaviyo">...</div>
//       <div data-import-guide-target="guide" data-platform="mailchimp" class="hidden">...</div>
//     </div>
//   </div>
//
export default class extends Controller {
  static targets = ["content", "button", "buttonLabel", "guide", "selector"]
  static values = { expanded: { type: Boolean, default: false } }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.contentTarget.classList.toggle("hidden", !this.expandedValue)

    if (this.hasButtonLabelTarget) {
      this.buttonLabelTarget.textContent = this.expandedValue ? "Hide import guide" : "How to import"
    }
  }

  switchPlatform() {
    const selected = this.selectorTarget.value

    this.guideTargets.forEach((guide) => {
      if (guide.dataset.platform === selected) {
        guide.classList.remove("hidden")
      } else {
        guide.classList.add("hidden")
      }
    })
  }
}
